export enum StockValueBySupplierTypes {
  //Grid
  GET_STOCK_VALUE_BY_SUPPLIER_LIST_LOADING = "@@stockValueBySupplier/GET_STOCK_VALUE_BY_SUPPLIER_LIST_LOADING",
  GET_STOCK_VALUE_BY_SUPPLIER_LIST_SUCCESS = "@@stockValueBySupplier/GET_STOCK_VALUE_BY_SUPPLIER_LIST_SUCCESS",
  GET_STOCK_VALUE_BY_SUPPLIER_LIST_ERROR = "@@stockValueBySupplier/GET_STOCK_VALUE_BY_SUPPLIER_LIST_ERROR",

  GET_SUPPLIER_DROPDOWN_LOADING = "@@stockValueBySupplier/GET_SUPPLIER_DROPDOWN_LOADING",
  GET_SUPPLIER_DROPDOWN_SUCCESS = "@@stockValueBySupplier/GET_SUPPLIER_DROPDOWN_SUCCESS",
  GET_SUPPLIER_DROPDOWN_ERROR = "@@stockValueBySupplier/GET_SUPPLIER_DROPDOWN_ERROR",
}